import React from 'react';
import './Title.module.scss';

type Props = {
  item: any;
};

export default function Title({ item }: Props) {
  console.log(item);
  return <h2 styleName="title">{item.attributes.title}</h2>;
}
